import { ReactNode } from "react"

import CompanyForm from './CompanyForm'
import PersonAdd from '../person/PersonAdd'
import { PersonProps, PersonState } from "../EntityEdit"

import Modal from "../../../libs/ui/modal/Modal"
import ModalWaith from "../../../libs/ui/modal/ModalWaith"
import Radio from "../../../libs/ui/inputs/Radio"

import { authFetch } from '../../../libs/cookie/Cookie'

import { ADD_UPDATE_COMPANY_URL } from '../../../costants'

import { Company } from "../../../libs/user/Company"

import { 
    STREET_ADDRES_PATTERN, P_IVA_PATTERN,
    isValid, isEmpty 
} from "../../../libs/validation/stringRegex"

interface CompanyAddProps extends PersonProps {
    company?: Company
    expiredSessionCallbak: Function
}
interface CompanyAddStatus extends PersonState {
    nomeAzienda: string | undefined,
    ragioneSociale: string | undefined,
    pIva: string | undefined,

    nomeAziendaError?: string | undefined,
    ragioneSocialeError?: string | undefined,
    pIvaError?: string | undefined,

    waith: boolean
}

class CompanyAddUpdate extends PersonAdd<CompanyAddProps, CompanyAddStatus> {
    constructor (props: any) {
        super (props)

        this.state = this.getInitialState(props)

        this.updateNomeAzienda = this.updateNomeAzienda.bind(this)
        this.updateRagioneSociale = this.updateRagioneSociale.bind(this)
        this.updatePIva = this.updatePIva.bind(this)
        this.updateIndirizzo = this.updateIndirizzo.bind(this)

        this.clearNomeAziendaError = this.clearNomeAziendaError.bind(this)
        this.clearRagioneSocialeError = this.clearRagioneSocialeError.bind(this)
        this.clearPIvaError = this.clearPIvaError.bind(this)
        this.clearIndirizzoSedeLegaleError = this.clearIndirizzoSedeLegaleError.bind(this)
    }

    render(): ReactNode {
        const cmp = this.props.company
        
        return (
            <>
                {cmp === undefined &&
                    <div className="form-group radioOption">
                        <Radio
                            id='new_company'
                            key='new_company'
                            value={undefined}
                            checked={false}
                            callback={undefined}
                            onClick={this.toggle}
                        >
                            <span>
                                <strong>Inserisci un nuovo contraente</strong>
                            </span>
                        </Radio>
                    </div>
                }
                {cmp !== undefined &&
                    <span 
                        id={'editButton_'+cmp.id}
                        className='editButton'
                        onClick={this.toggle}
                    >
                        Modifica i dati
                    </span>
                }

                <Modal
                    title={cmp?.legal_name ?? 'Nuovo contraente'}
                    buttonText='Salva'
                    isOpen={this.state.isOpen && !this.state.waith}
                    callBackToggle={this.toggle}
                    callBackSendData={this.sendData}
                    error={this.state.globalError}
                >
                    {cmp !== undefined &&
                        <span>
                            <strong className="titleLev6">Informazioni principali</strong><br/>
                        </span>
                    }
                    
                    <CompanyForm 
                        nome={this.state.nome}
                        cognome={this.state.cognome}
                        email={this.state.email}
                        cellulare={this.state.cellulare }
                        professione={undefined}
                        profList={undefined}
                        nomeAzienda={this.state.nomeAzienda}
                        ragioneSociale={this.state.ragioneSociale}
                        pIva={this.state.pIva}
                        indirizzoSedeLegale={this.state.indirizzoResidenza}
                        
                        updateName={this.updateName}
                        updateCognome={this.updateCognome}
                        updateEmail={this.updateEmail}
                        updateCellulare={this.updateCellulare}
                        updateProfessione={this.updateProfessione}
                        updateNomeAzienda={this.updateNomeAzienda}
                        updateRagioneSociale={this.updateRagioneSociale}
                        updatePiva={this.updatePIva}

                        updateIndirizzo={this.updateIndirizzo}
                        updateAllAddressParts={this.updateAllAddressParts}

                        nomeError={this.state.nomeError}
                        cognomeError={this.state.cognomeError}
                        emailError={this.state.emailError}
                        phoneError={this.state.phoneError}
                        profeError={this.state.profeError}
                        nomeAziendaError={this.state.nomeAziendaError}
                        ragioneSocialeError={this.state.ragioneSocialeError}
                        pIvaError={this.state.pIvaError}
                        indirizzoSedeLegaleError={this.state.indirizzoResidenzaError}

                        clearNomeError={this.clearNameError}
                        clearCognomeError={this.clearCognomeError}
                        clearEmailError={this.clearEmailError}
                        clearPhoneError={this.clearCellulareError}
                        clearProfeError={this.clearProfessioneError}
                        clearNomeAziendaError={this.clearNomeAziendaError}
                        clearRagioneSocialeError={this.clearRagioneSocialeError}
                        clearPIvaError={this.clearPIvaError}
                        clearIndirizzoSedeLegaleError={this.clearIndirizzoSedeLegaleError}
                    />
                </Modal>

                <ModalWaith isOpen={this.state.waith}/>
            </>
        )
    }

    sendData(): void {
        const error = this.getValidationError()
        const waith = error === undefined

        this.printError(error, waith)

        if (waith) {

            authFetch (
                ADD_UPDATE_COMPANY_URL,
                {
                    method: "post",
                    body: JSON.stringify({
                        id: (this.props?.company?.id ?? ''),
                        legal_name: this.state.ragioneSociale,
                        name: this.state.nomeAzienda,
                        referent_email: this.state.email,
                        referent_first_name: this.state.nome,
                        referent_last_name: this.state.cognome,
                        referent_phone: this.state.cellulare,
                        registered_office_address: this.state.indirizzoResidenza,
                        vat: this.state.pIva
                    })
                },
                this.props.expiredSessionCallbak
            ).then ( jsonObj => {

                if (jsonObj?.success === false) {
                    this.printError ( jsonObj.error_code )
                } else {
                    this.setState(
                        this.getInitialState(), 
                        () => {
                            if (this.props.callbackUser) {
                                this.props.callbackUser ()
                            }
                        }
                    )
                }
            })
        }
    }

    getValidationError () : string | undefined {
        if (
            isEmpty(this.state.nomeAzienda) || 
            (this.state.nomeAzienda?.length ?? 0) <= 2
        ) {
            return 'NOME_AZIENDA'
        }
        else if (!isValid(this.state.pIva, P_IVA_PATTERN)) {
            return 'PIVA'
        }
        else if (
            isEmpty(this.state.ragioneSociale) || 
            (this.state.ragioneSociale?.length ?? 0) <= 2
        ) {
            return 'RAGIONE'
        }
        else if (!isValid(this.state.indirizzoResidenza, STREET_ADDRES_PATTERN)) {
            return 'INDIRIZZO'
        }
        else { 
            let error = super.getValidationError ()

            if (
                error && 
                error !== 'SESSO' &&
                error !== 'DATA_NASCITA' &&
                error !== 'NATO_IN_ITALIA' &&
                error !== 'STATO_NASCITA' &&
                error !== 'COMUNE_NASCITA' &&
                error !== 'PROFESSIONE'
            ) {
                return error;
            }
        }

        return undefined;
    }
    printError (errorString: string | undefined, waith: boolean = false) {
        let nomeAziendaErro = undefined
        let ragioneSocialeErro = undefined
        let pIvaErro = undefined
        let indirizzoResidenzaErro = undefined
        let global = undefined

        if (errorString === 'NOME_AZIENDA') {
            nomeAziendaErro = 'Nome non valido'
            global= nomeAziendaErro
        }
        else if (errorString === 'PIVA') {
            pIvaErro = 'Numero di Partita IVA non valido'
            global= pIvaErro
        }
        else if (errorString === 'RAGIONE') {
            ragioneSocialeErro = 'Ragione sociale non valida'
            global= ragioneSocialeErro
        }
        else if (errorString === 'INDIRIZZO') {
            indirizzoResidenzaErro = 'Indirizzo non valido'
            global= indirizzoResidenzaErro
        }

        this.setState ({
            waith: waith,
            nomeAziendaError: nomeAziendaErro,
            pIvaError: pIvaErro,
            ragioneSocialeError: ragioneSocialeErro,
            indirizzoResidenzaError: indirizzoResidenzaErro,
            globalError: global
        }, () => {
            super.printError( errorString, waith )
        })
    }

    getInitialState (props?: any) {
        const cmp = props?.company

        const address = (cmp?.registered_office_address && cmp?.registered_office_addressNumber)
            ? cmp.registered_office_address + ' ' + cmp.registered_office_addressNumber
            : (cmp?.registered_office_address) ? cmp.registered_office_address : undefined

        const partialStaus = (cmp !== undefined)
            ?   {
                    ...super.getInitialState( cmp ),
                    ...{
                        id: cmp?.id ?? '',
                        nomeAzienda: cmp?.name,
                        ragioneSociale: cmp?.legal_name,
                        pIva: cmp?.vat,
                        
                        indirizzoResidenza: address,
                        is_manual_address: (cmp.is_manual_address !== undefined) ? cmp.is_manual_address !== undefined : false,

                        nomeAziendaError: undefined,
                        ragioneSocialeError: undefined,
                        pIvaError: undefined,
                        indirizzoResidenzaError: undefined,
                        waith: false
                    }
                }
            :   {
                    ...super.getInitialState(),
                    ...{
                        id: this.state?.id ?? '',
                        nome: this.state?.nome,
                        cognome: this.state?.cognome,
                        email: this.state?.email,
                        cellulare: this.state?.cellulare,
                        nomeAzienda: this.state?.nomeAzienda,
                        ragioneSociale: this.state?.ragioneSociale,
                        pIva: this.state?.pIva,
                        indirizzoResidenza: this.state?.indirizzoResidenza,
                        is_manual_address: (this.state.is_manual_address !== undefined) ? this.state.is_manual_address !== undefined : false,
                        nomeAziendaError: undefined,
                        ragioneSocialeError: undefined,
                        pIvaError: undefined,
                        indirizzoResidenzaError: undefined,
                        waith: false
                    }
                }

        return partialStaus
    }

    private updateNomeAzienda (val: string | undefined) {
        this.setState({
            nomeAzienda: val
        })
    }
    private updateRagioneSociale (val: string | undefined) {
        this.setState({
            ragioneSociale: val
        })
    }
    private updatePIva (val: string | undefined) {
        this.setState({
            pIva: val
        })
    }
    private updateIndirizzo (val: string | undefined) {
        this.setState({
            indirizzoResidenza: val
        })
    }

    private clearNomeAziendaError () {
        this.setState({
            nomeAziendaError: undefined
        })
    }
    private clearRagioneSocialeError () {
        this.setState({
            ragioneSocialeError: undefined
        })
    }
    private clearPIvaError () {
        this.setState({
            pIvaError: undefined
        })
    }
    private clearIndirizzoSedeLegaleError () {
        this.setState({
            indirizzoResidenzaError: undefined
        })
    }
}

export default CompanyAddUpdate